export default "__VITE_PUBLIC_ASSET__0953d74d__"